import React from "react";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const showBackground =
    window.location.pathname === "/games" 
  return (
    <div className={`${!showBackground && "md:px-3"} flex flex-col`}>
      {children}
    </div>
  );
};

export default Layout;
